// API Configuration
import axios from 'axios';

// Get API URL with priority:
// 1. Runtime config (from public/config.js - can be changed after build)
// 2. Build-time environment variable (from .env files)
// 3. Default fallback
const getApiUrl = () => {
  // Check for runtime configuration (loaded from public/config.js)
  if (window.REACT_APP_CONFIG && window.REACT_APP_CONFIG.API_URL) {
    return window.REACT_APP_CONFIG.API_URL;
  }
  
  // Check for build-time environment variable
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Default fallback
  return 'http://localhost:8000/api';
};

const API_BASE_URL = getApiUrl();

// Log API URL for debugging
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 API Configuration:');
  console.log('   Base URL:', API_BASE_URL);
  console.log('   Environment:', process.env.NODE_ENV);
  const source = window.REACT_APP_CONFIG?.API_URL 
    ? 'Runtime config (config.js)' 
    : process.env.REACT_APP_API_URL 
      ? 'Environment variable' 
      : 'Default fallback';
  console.log('   Source:', source);
} else {
  // Log in production build
  console.log('🌐 API Configuration:', API_BASE_URL);
  console.log('   Source:', window.REACT_APP_CONFIG?.API_URL ? 'Runtime config (config.js)' : 'Build-time config');
}

// Create axios instance with default configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: false,
});

// Request interceptor (optional - for adding auth tokens, etc.)
api.interceptors.request.use(
  (config) => {
    // You can add auth tokens or modify request here
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor (optional - for handling errors globally)
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle errors globally if needed
    return Promise.reject(error);
  }
);

export default api;
export { API_BASE_URL };

